import React from 'react';
import classnames from 'classnames';
import Grid from '@material-ui/core/Grid';
import { AppContext } from '../../AppProvider';
import { MINUTES_IN_A_HOUR } from '../../constants/constants';

export class BasicInfo extends React.Component {
  state = { loading: true };

  componentDidMount() {
    const { isPropelAdministrator } = this.context.globalProps;
    this.setState({
      isPropelAdministrator,
      loading: false
    });
  }

  render() {
    const { t, classes, carrier } = this.props;
    const { isPropelAdministrator, loading } = this.state;
    const {
      referenceData: { netTerms }
    } = this.context.globalProps;

    const getNetTerms = (netTerms, netTermsId) => {
      if (!netTermsId) {
        return null;
      }
      const netTerm = netTerms.find(netTerm => netTerm.value === netTermsId);
      if (netTerm) {
        return netTerm.title;
      }
      return null;
    };

    if (loading) return null;
    return (
      <div className={classes.detailsSection}>
        <h2 className={classnames(classes.headline7, classes.infoTitle)}>
          {t('Basic Information')}
        </h2>
        <Grid container spacing={16}>
          <Grid item lg={6} className={classes.gridItem}>
            <p className={classnames(classes.subtitle3, classes.infoItemTitle)}>
              {t('Carrier Name')}
            </p>
            <p className={classes.body2}>{carrier.name || '--'}</p>
          </Grid>
          <Grid item lg={6} className={classes.gridItem}>
            <p className={classnames(classes.subtitle3, classes.infoItemTitle)}>
              {t('External ID')}
            </p>
            <p className={classes.body2}>{carrier.externalId || '--'}</p>
          </Grid>
          <Grid item lg={6} className={classes.gridItem}>
            <p className={classnames(classes.subtitle3, classes.infoItemTitle)}>
              {t('SCAC')}
            </p>
            <p className={classes.body2}>{carrier.scac || '--'}</p>
          </Grid>
          <Grid item lg={6} className={classes.gridItem}>
            <p className={classnames(classes.subtitle3, classes.infoItemTitle)}>
              {t('Minimum Lead Time')}
            </p>
            <p className={classes.body2}>
              {carrier.leadTimeWindowMinutes
                ? carrier.leadTimeWindowMinutes / MINUTES_IN_A_HOUR
                : '--'}
            </p>
          </Grid>
          <Grid item lg={6} className={classes.gridItem}>
            <p className={classnames(classes.subtitle3, classes.infoItemTitle)}>
              {t('Rating Phone Number')}
            </p>
            <p className={classes.body2}>{carrier.ratingPhoneNumber || '--'}</p>
          </Grid>
          <Grid item lg={6} className={classes.gridItem}>
            <p className={classnames(classes.subtitle3, classes.infoItemTitle)}>
              {t('Rating URL')}
            </p>
            <p className={classes.body2}>
              {carrier.ratingUrl ? (
                <a className={classes.url} href={carrier.ratingUrl}>
                  {carrier.ratingUrl}
                </a>
              ) : (
                '--'
              )}
            </p>
          </Grid>
          <Grid item lg={6} className={classes.gridItem}>
            <p className={classnames(classes.subtitle3, classes.infoItemTitle)}>
              {t('Dispatch Phone Number')}
            </p>
            <p className={classes.body2}>
              {carrier.dispatchPhoneNumber || '--'}
            </p>
          </Grid>
          <Grid item lg={6} className={classes.gridItem}>
            <p className={classnames(classes.subtitle3, classes.infoItemTitle)}>
              {t('Dispatch URL')}
            </p>
            <p className={classes.body2}>
              {carrier.dispatchUrl ? (
                <a className={classes.url} href={carrier.dispatchUrl}>
                  {carrier.dispatchUrl}
                </a>
              ) : (
                '--'
              )}
            </p>
          </Grid>
          <Grid item lg={6} className={classes.gridItem}>
            <p className={classnames(classes.subtitle3, classes.infoItemTitle)}>
              {t('Customer Service Phone Number')}
            </p>
            <p className={classes.body2}>
              {carrier.customerServicePhoneNumber || '--'}
            </p>
          </Grid>
          <Grid item lg={6} className={classes.gridItem}>
            <p className={classnames(classes.subtitle3, classes.infoItemTitle)}>
              {t('MC Number')}
            </p>
            <p className={classes.body2}>{carrier.mcNumber || '--'}</p>
          </Grid>
          <Grid item lg={6} className={classes.gridItem}>
            <p className={classnames(classes.subtitle3, classes.infoItemTitle)}>
              {t('DUNS Number')}
            </p>
            <p className={classes.body2}>{carrier.dunsNumber || '--'}</p>
          </Grid>
          <Grid item lg={6} className={classes.gridItem}>
            <p className={classnames(classes.subtitle3, classes.infoItemTitle)}>
              {t('US DOT Number')}
            </p>
            <p className={classes.body2}>{carrier.usDotNumber || '--'}</p>
          </Grid>
          <Grid item lg={6} className={classes.gridItem}>
            <p className={classnames(classes.subtitle3, classes.infoItemTitle)}>
              {t('Federal EIN Number')}
            </p>
            <p className={classes.body2}>{carrier.federalEinNumber || '--'}</p>
          </Grid>
          <Grid item lg={6} className={classes.gridItem}>
            <p className={classnames(classes.subtitle3, classes.infoItemTitle)}>
              {t('Net Terms')}
            </p>
            <p className={classes.body2}>
              {getNetTerms(netTerms, carrier.netTermsId) || '--'}
            </p>
          </Grid>
          {isPropelAdministrator && (
            <Grid item lg={6} className={classes.gridItem}>
              <p
                className={classnames(classes.subtitle3, classes.infoItemTitle)}
              >
                {t('P44 Account Code')}
              </p>
              <p className={classes.body2}>{carrier.p44AccountCode || '--'}</p>
            </Grid>
          )}
        </Grid>
      </div>
    );
  }
}
BasicInfo.contextType = AppContext;

export default BasicInfo;
